// extracted by mini-css-extract-plugin
export default {"root":"Consumer_root__mggYf","line":"Consumer_line__ya1cG"};